<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="col-12">
        <div class="card-body">
          <contato-solicitacoes
              :telefone_tipo="tipo_telefone"
              :list_email="list_email"
              :list_telefone="list_telefone">
          </contato-solicitacoes>
          <div class="row">
            <div class="col-6">
              <b-form-group class="mt-3 text-left">
                <button type="button"
                        @click="voltar"
                        title="Salvar dados da empresa"
                        class="btn btn-dark">
                  <i class="bx bx-arrow-back"></i> Voltar
                </button>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group class="mt-3 text-right">
                <button type="button"
                        @click="saveDadosContatos()"
                        title="Salvar dados da empresa"
                        class="btn btn-success">
                  <i class="bx bx-check-double"></i> Salvar dados fiscais
                </button>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import ContatoSolicitacoes from "@/router/views/contribuinte/components/contato-solicitacoes"

const {notifySucesso, notifyErro} = require("../../../../../helps/notificacao");
const {getDadosContatos, putDadosContatos} = require("../../../../../api/admin/gestao/empresas");

export default {
  components: {
    Loader,
    Aguarde,
    ContatoSolicitacoes
  },
  props: {
    tipo_telefone: {
      type: Array,
      default: function () {
        return [];
      },
    },
    eco_codigo: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      showAguarde: false,
      httpSend: false,
      list_email: [],
      list_telefone: [],
    };
  },
  created() {
    this.getDados();
  },
  methods: {
    getDados() {
      this.httpSend = true;
      getDadosContatos(this.eco_codigo).then(response => {
        if (response.status) {
          this.conversaoEmail(response.dados.email)
          this.conversaoTelefone(response.dados.telefone)
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveDadosContatos() {
      if (this.list_email.length < 1) {
        notifyErro("DattaNFSe", "Necessário informar no mínimo um e-mail")
        return false
      }
      if (this.list_telefone.length < 1) {
        notifyErro("DattaNFSe", "Necessário informar no mínimo um telefone")
        return false
      }
      const email = this.desconverterEmail(this.list_email);
      const telefone = this.desconverterTelefone(this.list_telefone);

      this.httpSend = true;
      putDadosContatos({eco_codigo: this.eco_codigo, eco_email: email, eco_telefone: telefone}).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    conversaoEmail(email) {
      const email_array = [];
      email.forEach(function (e) {
        let _e = {
          tem_codigo: e.ema_codigo,
          tps_codigo: e.eco_codigo,
          tem_email: e.ema_email
        }
        email_array.push(_e);
      });
      this.list_email = email_array;
    },
    desconverterEmail(email) {
      const email_array = [];
      const eco = this.eco_codigo;
      email.forEach(function (e) {
        let _e = {
          ema_codigo: e.tem_codigo,
          eco_codigo: eco,
          ema_email: e.tem_email
        }
        email_array.push(_e);
      });
      return email_array;
    },
    conversaoTelefone(telefone) {
      const telefone_array = [];
      telefone.forEach(function (t) {
        let _t = {
          tfo_codigo: t.tel_codigo,
          tps_codigo: t.eco_codigo,
          tet_codigo: {
            tab_codigo: t.tab_codigo,
            tab_grupo: t.tab_grupo,
            tab_numero: t.tab_numero,
            tab_nome: t.tab_nome
          },
          tfo_contato: t.tel_contato,
          tfo_numero: t.tel_numero,
        }
        if (_t.tfo_contato === null) {
          _t.tfo_contato = t.tel_numero;
          _t.tfo_numero = null;
        }
        telefone_array.push(_t);
      });
      this.list_telefone = telefone_array;
    },
    desconverterTelefone(telefone) {
      const telefone_array = [];
      const eco = this.eco_codigo;
      telefone.forEach(function (t) {
        let _t = {
          tel_codigo: t.tfo_codigo,
          eco_codigo: eco,
          tet_codigo: t.tet_codigo.tab_codigo,
          tel_contato: t.tfo_contato,
          tel_numero: t.tfo_numero,
        }
        telefone_array.push(_t);
      });
      return telefone_array;
    },
    voltar() {
      this.$router.back();
    }
  }
};
</script>

